<template>
  <v-sheet class="mx-auto" max-width="2000">
    <v-card-text>
      <div class="project-overview-body" v-html="projectDescription"></div>
    </v-card-text>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'NeurologicalDiseaseProjectOverview',
  props: {
    icd: String,
    diseaseDescription: String,
    projectDescription: String,
    visible: Boolean
  },
});
</script>

<style scoped>
.project-overview-body :deep(h4) {
  margin-top: 1rem;
  margin-bottom: 0.25rem;
}

.project-overview-body :deep(ul) {
  margin: 0 0 1rem 0;
  padding-left: 0;
}

.project-overview-body :deep(li) {
  list-style-position: inside;
  margin: 0.2rem 0;
}
</style>
